<template>
  <div>
    <b-tooltip
      position="is-bottom"
      multilined
      :active="opened"
      always
      class="responsive-evaluation-help"
    >
      <b-button
        icon="help"
        :label="$t('instruction-panel.instruction.evaluation-howto')"
        type="is-primary"
        @click="opened = !opened"
      />
      <template #content>
        <div class="evaluation-help-tooltip-content">
          <h3>{{ criteria }}</h3>
          <span v-html="helpText" />
        </div>
      </template>
    </b-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BButton, BTooltip } from "buefy"

export default defineComponent({
  name: "ResponsiveEvaluationHelp",

  components: {
    BTooltip,
    BButton,
  },

  props: {
    criteria: {
      type: String,
    },
    helpText: {
      type: String,
    },
  },
  data() {
    return {
      opened: false,
    }
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.responsive-evaluation-help {
  padding-bottom: 20px;
  width: 100%;

  .tooltip-content {
    background-color: $sidepanel-background-color !important;

    .evaluation-help-tooltip-content {
      min-height: 200px;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      background-color: $sidepanel-background-color;

      h3 {
        color: $text-default-color;
        font-size: 18px;
        padding-bottom: 3px;
        font-weight: bolder;
      }

      span {
        color: $text-default-color;
      }
    }
  }

  .tooltip-trigger {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
